export enum NotificationTriggerStatus {
  UNSET_NOTIFICATION_TRIGGER_STATUS = 'UNSET_NOTIFICATION_TRIGGER_STATUS', // Do not use, needed because of proto3 limitations
  NOTIFICATION_TRIGGER_ACTIVATED = 'NOTIFICATION_TRIGGER_ACTIVATED',
  NOTIFICATION_TRIGGER_DELETED = 'NOTIFICATION_TRIGGER_DELETED',
}
